import APIService from "./APIService";

class ProgramsService extends APIService {
  search = async (search: string = "", page: number = 1, limit: number = 10, sort: string) => {
    const result = await this.get("programs/search?generic=" + search + "&page=" + page + "&limit=" + limit + "&sort=" + sort);
    return result ? result.data : null;
  };

  add = async (name: string, description: string, markets: string[], code: string) => {
    const result = await this.post(
      {
        name,
        description,
        markets,
        code,
      },
      "/programs"
    );
    return result ? result.data : null;
  };

  edit = async (id: string, name: string, description: string, markets: string[], code: string) => {
    const result = await this.put(
      {
        name,
        description,
        markets,
        code,
      },
      "programs/" + id
    );
    return result ? result.data : null;
  };

  delete = async (id: string) => {
    const result = await this.remove("programs/" + id);
    return result ? result.data : null;
  };

  getPrograms = async () => {
    const result = await this.get("programs/get-programs");
    return result ? result.data : null;
  };
}

export default ProgramsService;
